import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import ApiService from '../../../services/api.service';
const initialState = {
  sourceStatusType: [],
  status: false,
  error: null,
};
export const fetchSourceStatusType = createAsyncThunk(
  'master/fetchSourceStatusType',
  async (_, { getState, rejectWithValue }) => {
    const { sourceStatusType } = getState().sourceStatusType;
    if (sourceStatusType && sourceStatusType.length > 0) {
      return rejectWithValue('Source status type already fetched');
    } else {
      const response = await ApiService.get('/system/status?statusType=source');
      return response;
    }
  }
);
const sourceStatusTypeSlice = createSlice({
  name: 'sourceStatusType',
  initialState,
  reducers: {
    clearSourceStatusType: state => {
      state.sourceStatusType = [];
      state.status = false;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchSourceStatusType.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchSourceStatusType.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.sourceStatusType = action?.payload || [];
      })
      .addCase(fetchSourceStatusType.rejected, (state, action) => {
        if (action.payload === 'Source status type already fetched') {
          state.status = 'succeeded';
        } else {
          state.status = 'failed';
          state.error = action.error.message;
        }
      });
  },
});
export const { clearSourceStatusType } = sourceStatusTypeSlice.actions;

export const sourceStatusTypeReducer = sourceStatusTypeSlice.reducer;
